import {tableBodyClasses, tableCellClasses} from '@mui/material';
import {isFirefox} from '../utils/functions/user-agent';
import {Pallete} from './bluebird';

export const tableSx = {
  container: {
    position: 'absolute',
    overflowY: 'scroll',

    width: isFirefox ? '-moz-available' : '-webkit-fill-available',
    maxHeight: isFirefox ? '70%' : '-webkit-fill-available',

    boxShadow: '0px 4px 16px rgba(29, 41, 57, 0.15)',

    // borders
    marginTop: '16px',
    marginRight: '16px',
    marginBottom: '20px',
    borderRadius: '8px',
  },
  table: {
    marginBottom: '24px',
    padding: '0 21.5px 0 21.5px',
    width: '100%',
    borderSpacing: '0 14px',

    // body dividers
    [`& .${tableBodyClasses.root}`]: {
      [`& .${tableCellClasses.root}`]: {
        borderBottom: 'none',
      },
    },
  },
  header: {
    [`& .${tableCellClasses.root}`]: {
      backgroundColor: Pallete.white.base,
      color: Pallete.gray.base,
      fontSize: '18px',
      fontWeight: '600',
      lineHeight: '20px',
      letterSpacing: '0.25px',
      paddingTop: '29px',
      padding: 'calc(14px + 24px) 12px 14px 0',
      '&:first-of-type': {
        paddingLeft: '12px',
      },
    },
  },
  row: {
    color: Pallete.gray.base,
    fontSize: '14px',
    fontWeight: '500',
    letterSpacing: '0.25px',
    borderRadius: '5px',
    '& .MuiTableCell-root': {
      cursor: 'pointer',
      height: '40px',
      transition: 'background-color 0.2s ease-in-out',
      padding: '0 16px 0 0',
      '&:first-of-type': {
        paddingLeft: '12px',
        borderTopLeftRadius: '5px',
        borderBottomLeftRadius: '5px',
      },
      '&:last-of-type': {
        borderTopRightRadius: '5px',
        borderBottomRightRadius: '5px',
      },
    },
    '&:hover': {
      '& .MuiTableCell-root': {
        backgroundColor: 'var(--dcm-blue-hover)',
      },
    },
  },
};
